<template lang="pug">
aside-modal(id="end-shift-report", width="w-xxxl", :loading="loading")
    span.clear(slot="header-text") End Shift Report
    div.padding.end-shift-report(slot="body")
        h1.text-center(v-show="loading")
            v-loading(loader="fetch-drawer-session")
        div.p-a-xs(v-if="hasDrawerSession && ! loading", id="end-shift-report-content")
            div.row
                div.col-sm-12.p-l-sm.text-xs-center
                    span.text-lg._400 {{ outlet.name }}
                div.col-sm-5.text-xs-center.text-sm-right
                    span.avatar.w-64.m-b-sm
                        img(:src="staffImage")

                div.col-sm-7.p-l-sm.text-xs-center.text-sm-left
                    span.text-lg._300 End Shift Report
                    span.clear.text-md by {{ staff.name }}

            div.row.p-t-md
                div.col-xs-6.text-center.p-l-0.p-r-xs
                    div.clear.p-a-xs.session-time
                        | {{ dateFormat(drawerSession.time_open) }}
                    span.text-xs.text-uppercase Open
                div.col-xs-6.text-center.p-r-0.p-l-xs
                    div.clear.p-a-xs.session-time
                        | {{ dateFormat(drawerSession.time_close) }}
                    span.text-xs.text-uppercase Close

            div.row.p-t-sm
                div.col-xs-12.title-separator.black
                    span.text-md Sales

            div.row.p-t-sm(v-if="central.eod_gross_sales")
                div.col-xs-7 Gross Sales
                div.col-xs-2.text-center =
                div.col-xs-3.text-right {{ formattedNumber(totalGrossSales) }}

            div.row.p-t-sm(v-for="checkout in checkouts")
                div.col-xs-5 {{ checkout.name }}
                div.col-xs-2.text-center {{ checkout.total }}
                div.col-xs-2.text-center +
                div.col-xs-3.text-right {{ formattedNumber(checkout.totalSales) }}

            div.row.p-t-sm
                div.col-xs-7 Discount per Receipt
                div.col-xs-2.text-center -
                div.col-xs-3.text-right {{ formattedNumber(discountPerReceipt) }}

            div.row.p-t-sm
                div.col-xs-7 Voided Orders
                div.col-xs-2.text-center -
                div.col-xs-3.text-right {{ formattedNumber(voidedOrders) }}

            div.row.p-t-sm
                div.col-xs-7 Net Sales
                div.col-xs-2.text-center =
                div.col-xs-3.text-right {{ formattedNumber(netSales) }}

            div.row.p-t-sm
                div.col-xs-7 Total Taxes
                div.col-xs-2.text-center +
                div.col-xs-3.text-right {{ formattedNumber(totalTaxes) }}

            div.row.p-t-sm
                  div.col-xs-7 Total Charges
                  div.col-xs-2.text-center +
                  div.col-xs-3.text-right {{ formattedNumber(totalCharges) }}

            div.row.p-t-sm
                  div.col-xs-7 Total Sales
                  div.col-xs-2.text-center =
                  div.col-xs-3.text-right {{ formattedNumber(totalSalesAfterRounding) }}

            div.row.p-t-sm
                div.col-xs-7 Total Rounding
                div.col-xs-2.text-center +
                div.col-xs-3.text-right {{ formattedNumber(totalRounding) }}

            div.row.p-t-sm
                div.col-xs-7 Total Sales After Rounding
                div.col-xs-2.text-center =
                div.col-xs-3.text-right {{ formattedNumber(totalSales) }}

            div.row.p-t-sm(v-if="central.eod_average_sales")
                div.col-xs-12.title-separator.black
                  span.text-md Average Sales

            div.row.p-t-sm(v-if="central.eod_average_sales")
                div.col-xs-7 Average Sales
                div.col-xs-2.text-center =
                div.col-xs-3.text-right {{ formattedNumber(totalAverage) }}

            div.row.p-t-sm(v-if="!central.eod_tax_sales")
                div.col-xs-12.title-separator.black
                  span.text-md Taxes

            div.row.p-t-sm(v-if="!central.eod_tax_sales")(v-for="tax in taxList")
                div.col-xs-5 {{ tax.name }} ({{ tax.tax_amount }}%)
                div.col-xs-2.text-center {{ tax.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(tax.amount) }}

            div.row.p-t-sm(v-if="!central.eod_tax_sales")
                div.col-xs-5 Total
                div.col-xs-2.text-center {{ taxCount }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(totalTaxes) }}

            div.row.p-t-sm
                div.col-xs-12.title-separator.black
                    span.text-md Discount Detail

            div.row.p-t-sm(v-for="discount in discountList")
                div.col-xs-5 {{ discount.name }}
                div.col-xs-2.text-center {{ discount.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(Math.abs(discount.amount)) }}

            div.row.p-t-sm(v-for="modifier in modifierDiscountList")
                div.col-xs-5 {{ modifier.name }}
                div.col-xs-2.text-center {{ modifier.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(Math.abs(modifier.amount)) }}

            div.row.p-t-sm
                div.col-xs-5 Total
                div.col-xs-2.text-center {{ totalDiscount.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(Math.abs(totalDiscount.amount)) }}

            div.row.p-t-sm
                div.col-xs-12.title-separator.black
                    span.text-md Voided Sales

            div.row.p-t-sm
                div.col-xs-5 Voided Orders
                div.col-xs-2.text-center {{ totalVoidedOrders }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(voidedOrders) }}

            div.row.p-t-sm
                div.col-xs-5 Voided Sales
                div.col-xs-2.text-center {{ totalVoidedSales }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(voidedSales) }}

            //- addon list
            div.row.p-t-sm(v-if="modifierTopupList.length > 0")
                div.col-xs-12.title-separator.black
                    span.text-md Addons

            div.row.p-t-sm(v-for="modifier in modifierTopupList")
                div.col-xs-5 {{ modifier.name }}
                div.col-xs-2.text-center {{ modifier.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(Math.abs(modifier.amount)) }}

            div.row.p-t-sm
                div.col-xs-5 Total
                div.col-xs-2.text-center {{ totalAddon.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(Math.abs(totalAddon.amount)) }}

            div.row.p-t-sm
                div.col-xs-12.title-separator.black
                    span.text-md Payment

            div.row.p-t-sm(v-for="payment in paymentLists")
                    div.col-xs-5 {{ payment.name }}
                    div.col-xs-2.text-center {{ payment.total }}
                    div.col-xs-2.text-center
                    div.col-xs-3.text-right {{ formattedNumber(payment.amount) }}

            div.row.p-t-sm
                div.col-xs-5 Total
                div.col-xs-2.text-center {{ totalPayment.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(Math.abs(totalPayment.amount)) }}

            //- Activity
            div.row.p-t-sm
                div.col-xs-12.title-separator.black
                    span.text-md Activity

            div.row.p-t-sm
                div.col-xs-5 Float
                div.col-xs-2.text-center
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(drawerSession.opening_amount) }}

            div.row.p-t-sm
                div.col-xs-5 Cash In
                div.col-xs-2.text-center {{ cashIn.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(cashIn.amount) }}

            div.row.p-t-sm
                div.col-xs-5 Cash Out
                div.col-xs-2.text-center {{ cashOut.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(cashOut.amount) }}

            div.row.p-t-sm
                div.col-xs-5 Cash
                div.col-xs-2.text-center {{ cashSummary.total }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(cashSummary.amount) }}

            div.row.p-t-sm
                div.col-xs-5 Expected Drawer Amount
                div.col-xs-2.text-center
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(expectedDrawerAmount) }}

            div.row.p-t-sm
                div.col-xs-5 Drawer Amount
                div.col-xs-2.text-center
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(drawerSession.closing_amount) }}

            div.row.p-t-sm
                div.col-xs-5 Short / Extra
                div.col-xs-2.text-center
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(shortOrExtra) }}

            div.row.p-t-sm
                div.col-xs-12.title-separator.black
                    span.text-md Category Net Sales

            div.row.p-t-sm
                div.col-xs-5 Total
                div.col-xs-2.text-center {{ totalQtyNetSales }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ formattedNumber(totalNetSales) }}

            div.row.p-t-sm(v-for="catNettSale in catNettSales")
                div.col-xs-5 {{ catNettSale.category }}
                div.col-xs-2.text-center {{ catNettSale.total_quantity }}
                div.col-xs-2.text-center
                div.col-xs-3.text-right {{ catNettSale.total_net_sales }}

    button(
        slot="footer",
        :disabled="loading",
        @click="printPdf(outlet.name)",
        class="btn btn-fw dark"
    ) Print
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dateFormat from '../../../mixins/date-format';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';

export default {
    mixins: [dateFormat],
    data() {
        return {
            central: null,
        };
    },
    computed: {
        ...mapGetters('drawerSession', [
            'hasDrawerSession',
            'drawerSession',
            'outlet',
            'staff',
            'staffImage',
            'totalPax',
            'netSales',
            'totalSales',
            'voidedSales',
            'voidedOrders',
            'totalTaxes',
            'totalCharges',
            'totalRounding',
            'checkouts',
            'discountList',
            'payments',
            'totalDiscount',
            'cashIn',
            'cashOut',
            'cashSummary',
            'expectedDrawerAmount',
            'shortOrExtra',
            'totalTransaction',
            'totalVoidedSales',
            'totalVoidedOrders',
            'modifierDiscountList',
            'modifierTopupList',
            'totalAddon',
            'cancelledOrders',
            'totalCancelledOrders',
            'discountPerReceipt',
            'totalSalesAfterRounding',
            'paymentLists',
            'totalPayment',
            'catNettSales',
            'totalNetSales',
            'totalQtyNetSales',
            'totalAverage',
            'totalGrossSales',
            'taxList',
            'taxCount',
        ]),

        loading() {
            return this.onLoading('fetch-drawer-session');
        },
    },

    mounted() {
        this.getCentralSetting();
        this.reigisterEvent();
    },

    methods: {
        printPdf(outletName) {
            var element = document.getElementById('end-shift-report-content');

            var opt = {
                margin: 1,
                filename: `Drawer-Session-${outletName}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: {
                    unit: 'in',
                    format: 'letter',
                    orientation: 'portrait',
                },
            };

            // New Promise-based usage:
            html2pdf()
                .set(opt)
                .from(element)
                .save();
        },
        ...mapActions('drawerSession', ['getDrawerSession']),

        formattedNumber(data) {
            return numeral(data).format('0,0.00');
        },

        toggleModal(action) {
            $('#end-shift-report').modal(action);
        },

        reigisterEvent() {
            this.$on('show-end-shift-report', id => {
                this.toggleModal('show');
                this.getDrawerSession(id);
            });
        },

        getCentralSetting() {
            axios
                .get(
                    Laroute.route(
                        'franchise.report.drawersession.getCentralSetting',
                    ),
                )
                .then(
                    function(response) {
                        let data = response.data;
                        this.central = data;
                    }.bind(this),
                );
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/drawersession/end-shift-report.vue